import { z } from 'zod';

import {
  inventoryTrackingModeValues,
  type InventoryTrackingMode,
} from './holding-units.dto.js';
import type {
  GetHoldingUnitInventoryPolicyRequest,
  GetHoldingUnitInventoryPolicyResponse,
  HoldingUnitInventoryPolicyDto,
  ListHoldingUnitInventoryPoliciesRequest,
  ListHoldingUnitInventoryPoliciesResponse,
  SetHoldingUnitsInventoryPolicyRequest,
  SetHoldingUnitsInventoryPolicyResponse,
} from './holding-units-inventory-policy.dto.js';

export const InventoryTrackingModeSchema: z.ZodType<InventoryTrackingMode> = z.enum(
  inventoryTrackingModeValues,
);

export const HoldingUnitInventoryPolicyDtoSchema: z.ZodType<HoldingUnitInventoryPolicyDto> = z.object({
  companyId: z.uuid(),
  locationId: z.uuid(),
  materialId: z.uuid(),
  trackingMode: InventoryTrackingModeSchema,
});

export const GetHoldingUnitInventoryPolicyRequestSchema: z.ZodType<GetHoldingUnitInventoryPolicyRequest> =
  z.object({
    companyId: z.uuid(),
    locationId: z.uuid(),
    materialId: z.uuid(),
  });

export const GetHoldingUnitInventoryPolicyResponseSchema: z.ZodType<GetHoldingUnitInventoryPolicyResponse> =
  z.object({
    effectiveTrackingMode: InventoryTrackingModeSchema,
  });

export const ListHoldingUnitInventoryPoliciesRequestSchema: z.ZodType<ListHoldingUnitInventoryPoliciesRequest> =
  z.object({
    companyId: z.uuid(),
    locationId: z.uuid(),
  });

export const ListHoldingUnitInventoryPoliciesResponseSchema: z.ZodType<ListHoldingUnitInventoryPoliciesResponse> =
  z.object({
    items: z.array(HoldingUnitInventoryPolicyDtoSchema),
  });

export const SetHoldingUnitsInventoryPolicyRequestSchema: z.ZodType<SetHoldingUnitsInventoryPolicyRequest> =
  z.object({
    locationId: z.uuid(),
    materialId: z.uuid(),
    trackingMode: InventoryTrackingModeSchema,
  });

export const SetHoldingUnitsInventoryPolicyResponseSchema: z.ZodType<SetHoldingUnitsInventoryPolicyResponse> =
  z.object({
    policy: HoldingUnitInventoryPolicyDtoSchema,
  });
